import Vue from 'vue'
// 项目类型 字段映射
export function projectTypeMapperName(type){
    switch(type){
        case 'GC':return '工程建设';break;
        case 'CG':return '政府采购';break;
        case 'CQ':return '国有产权';break;
        case 'GT':return '国土交易';break;
        case 'QT':return '其他';break;
    }
}
export function typeMapperProjectNameDesc(type){
    switch(type){
        case 'GC':return '招标项目名称';break;
        case 'CG':return '采购项目名称';break;
        case 'CQ':return '项目名称';break;
        case 'GT':return '项目名称';break;
        case 'QT':return '项目名称';break;
        default:return '项目名称';break;
    }
}
export function typeMapperProjectCodeDesc(type){
    switch(type){
        case 'GC':return '招标项目编号';break;
        case 'CG':return '采购项目编号';break;
        case 'CQ':return '项目编号';break;
        case 'GT':return '项目编号';break;
        case 'QT':return '项目编号';break;
        default:return '项目编号';break;
    }
}
export function typeMapperBidNameDesc(type){
    switch(type){
        case 'GC':return '标段名称';break;
        case 'CG':return '包件名称';break;
        case 'CQ':return '标的名称';break;
        case 'GT':return '标的名称';break;
        case 'QT':return '标的名称';break;
        default:return '标的名称';break;
    }
}
export function typeMapperBidCodeDesc(type){
    switch(type){
        case 'GC':return '标段编号';break;
        case 'CG':return '包件编号';break;
        case 'CQ':return '标的编号';break;
        case 'GT':return '标的编号';break;
        case 'QT':return '所属项目编号';break;
        default:return '所属项目编号';break;
    }
}
export function typeMapperTraddingModDesc(type){
    switch(type){
        case 'GC':return '招标方式';break;
        case 'CG':return '采购方式';break;
        case 'CQ':return '交易方式';break;
        case 'GT':return '交易方式';break;
        case 'QT':return '交易方式';break;
    }
}
export function typeMapperTraddingTimeDesc(type){
    switch(type){
        case 'GC':return '开标时间';break;
        case 'CG':return '开标时间';break;
        case 'CQ':return '竞价开始时间';break;
        case 'GT':return '竞价开始时间';break;
        case 'QT':return '竞价开始时间';break;
        default:return '竞价开始时间';break;
    }
}

// 大于99变成99+
export function more99Filter(value){
	if(value){
		return Number(value)>=99?'99+':Number(value);
	}else{
		return 0;
	}
}

// 采购方式
export function purmethodFilter(value){
    switch(value){
		case '1': return '公开招标';break;
		case '2': return '邀请招标';break;
		default:return '公开招标';break;
	}
}

// 资格审查办法
export function calculatetypeFilter(value){
	switch(value){
		case '1': return '资格预审';break;
		case '2': return '资格后审';break;
		default:return '资格预审';break;
	}
}
// 判断是否为空,空则为/
export function projectIsEmpty(value){
	if(!value){
		return '/';
	}else{
		return value;
	}
}

Vue.filter('formatDate', function (date, format) {
    format = format || 'yyyy-MM-dd hh:mm:ss';
    date = new Date(date);
    let o = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    // RegExp.$1是RegExp的一个属性,指的是与正则表达式匹配的第一个 子匹配(以括号为标志)字符串
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length));//获取年份
    for (let k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k] :
            ("00" + o[k]).substr(("" + o[k]).length));
    return format;
})

